/**
 * 门户顶栏是否展示该菜单：enabled 关闭直接隐藏，再看当前语言是否使用。
 * 菜单按 locale 请求，未显式传入 locale 时用接口折算好的 portalVisible。
 * 隐藏只影响导航入口，菜单数据仍保留供页面与横幅使用。
 */

/** 菜单是否出现在门户顶栏 / 页内分类导航 */
export function isPortalMenuVisible(item, locale) {
  if (!item) return false
  if (item.enabled === false) return false

  const visibilities = item.portalVisibilities
  if (locale && visibilities && Object.prototype.hasOwnProperty.call(visibilities, locale)) {
    return visibilities[locale] !== false
  }

  if (typeof item.portalVisible === 'boolean') return item.portalVisible
  return true
}
